import { isArray } from 'lodash';
import { combineReducers } from 'redux';
import adminUsers from '../reducers/admin/adminUsers.js';

import processingCatalogs from '../reducers/catalogs/catalogInProcesses.js';
import catalogJobs from '../reducers/catalogs/catalogJobs.js';
import invalidCatalogs from '../reducers/catalogs/catalogWithErrors.js';
import processedCatalogs from '../reducers/catalogs/processedCatalogs.js';
import vendorProcessedCatalogs from '../reducers/catalogs/vendorProcessedCatalogs.js';

import invoices from '../reducers/invoices/invoices.js';
import products from '../reducers/product/products.js';

import affiliate from '../reducers/affiliate.js';
import affiliateAccountSettings from '../reducers/affiliateAccountSettings.js';
import customerInvoices from '../reducers/CustomerInvoices.js';

import payment from '../reducers/payment.js';
import referals from '../reducers/referalUsers.js';
import sales from '../reducers/sales.js';
import shipments from '../reducers/shipments.js';
import userInvoices from '../reducers/userInvoices.js';

import vendors from '../reducers/vendors.js';
import workers from '../reducers/workers.js';

import auth from '../slices/auth';
import internalStorage from '../slices/internalStorage';
import store from '../slices/store';
import warehouse from '../slices/warehouse';

import account from '../slices/account';
import fbaInbound from '../slices/fba-inbound';
import fbaShipment from '../slices/fba-shipment.js';
import fbaInboundShipment from '../slices/fba-inbound-new.js';
import threeLayerProducts from '../slices/3-layer-products.js';
import pos from '../slices/po.js';
import locationManagement from '../slices/location-management'
import vendorItems from '../slices/vendor-items';
import workOrders from '../slices/work-orders';
import shipmentPlan from '../slices/shipment-plan.js';
import postShipment from '../slices/post-shipment.js';
import address from '../slices/address.js';
import packingStats from '../slices/packing-stats.js';

import awsServices from "../slices/aws-services.js"
import catalog from "../slices/catalog.js"
import dashboard from "../slices/dashboard.js"

const index = combineReducers({
  adminUsers,

  processingCatalogs,
  catalogJobs,
  invalidCatalogs,
  processedCatalogs,
  vendorProcessedCatalogs,

  invoices,

  products,

  affiliate,
  affiliateAccountSettings,

  customerInvoices,
  payment,
  referals,
  sales,
  shipments,

  userInvoices,
  vendors,
  workers,

  auth,
  store,

  warehouse,
  account,

  internalStorage,
  fbaInbound,
  fbaShipment,
  fbaInboundShipment,

  threeLayerProducts,
  pos,
  locationManagement,
  vendorItems,
  workOrders,
  shipmentPlan,
  postShipment,
  address,
  packingStats,
  awsServices,
  catalog,
  dashboard
});


const rootReducer = (state, action) => {
  let { reducers } = action || {};

  if (reducers && action.type === 'RESET_APP') {
    if (!isArray(reducers)) reducers = [reducers];

    for (let i = 0; i < reducers.length; i += 1) {
      const red = reducers[i];
      if (state[red]) {
        state[red] = undefined;
      }
    }
  }

  return index(state, action);
}
export default rootReducer;
